import $ from 'jquery';

const DRAFT_COOKIE = 'ms_calc_draft';
const DRAFT_DAYS = 1;

// Reopens the calculator with values from a saved calculation link.
function restoreFromUrl() {
    const params = new URLSearchParams(location.search);
    const isin = params.get('isin');
    if (!isin) {
        return;
    }

    const $select = $('#ovdp-bond-select');
    if (!$select.find(`option[value="${CSS.escape(isin)}"]`).length) {
        $('.ovdp-currency-tab[data-currency="ALL"]').trigger('click');
    }
    // the "up to 2 years" filter hides long issues, and a link must not silently open another bond
    if (!$select.find(`option[value="${CSS.escape(isin)}"]`).length) {
        $('#ovdp-filter-max-2y').prop('checked', false).trigger('change');
    }
    if ($select.find(`option[value="${CSS.escape(isin)}"]`).length) {
        $select.val(isin).trigger('change');
    }

    const price = parseFloat(params.get('price'));
    if (price > 0) {
        $('#ovdp-bond-price-input').val(price).trigger('input');
    }
    const count = parseInt(params.get('count'), 10);
    if (count > 0) {
        $('#ovdp-bonds-count-input').val(count).trigger('input');
    }
}

function currentInput(next) {
    return {
        isin: $('#ovdp-bond-select').val(),
        count: parseInt($('#ovdp-bonds-count-input').val(), 10),
        price: parseFloat($('#ovdp-bond-price-input').val()) || 0,
        next
    };
}

// Functional cookie set only after an explicit click, so the choice survives signup or sign-in.
// Short-lived: a forgotten click must not reopen the form at an unrelated sign-in days later.
function writeDraftCookie(input) {
    const value = encodeURIComponent(JSON.stringify({ i: input.isin, n: input.count, p: input.price, a: input.next }));
    const secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${DRAFT_COOKIE}=${value}; path=/; max-age=${DRAFT_DAYS * 86400}; SameSite=Lax${secure}`;
}

// The canonical tag ignores these parameters, so shared links create no duplicate pages.
function shareUrl(input) {
    const url = new URL(location.origin + location.pathname);
    url.searchParams.set('isin', input.isin);
    url.searchParams.set('count', input.count);
    if (input.price > 0) {
        url.searchParams.set('price', input.price);
    }
    url.searchParams.set('utm_source', 'share');
    url.searchParams.set('utm_medium', 'calculator');
    url.searchParams.set('utm_campaign', 'ovdp');
    return url.toString();
}

function showStatus($panel, text, isError) {
    const $status = $('#ovdp-save-status');
    $status.text(text).prop('hidden', false).toggleClass('text-danger', isError).toggleClass('text-success', !isError);
}

function renderList($panel, items) {
    const $wrap = $('#ovdp-saved-list-wrap');
    const $list = $('#ovdp-saved-list').empty();
    $wrap.prop('hidden', !items.length);

    items.forEach(item => {
        const $row = $('<li class="d-flex flex-wrap align-items-center justify-content-between gap-2 py-1"></li>');
        $('<span class="text-body text-break"></span>').text(`${item.name} · ${item.count} · ${Math.round(item.invested)} ${item.currency} · ${item.date}`).appendTo($row);
        const $actions = $('<span class="d-inline-flex gap-2"></span>').appendTo($row);
        $('<a class="text-primary fw-semibold"></a>').attr('href', item.url).text($panel.data('text-open')).appendTo($actions);
        if (item.addUrl) {
            $('<a class="text-primary fw-semibold"></a>').attr('href', item.addUrl).text($panel.data('text-add')).appendTo($actions);
        }
        $list.append($row);
    });
}

function loadList($panel) {
    $.getJSON($panel.data('list-url')).done(result => {
        if (result.success) {
            renderList($panel, result.items);
        }
    });
}

export function initOvdpSavePanel() {
    restoreFromUrl();

    const $panel = $('#ovdp-save-panel');
    if (!$panel.length) {
        return;
    }

    const isAuthenticated = String($panel.data('authenticated')) === '1';

    $panel.on('click', '[data-share]', function (event) {
        const input = currentInput();
        if (!input.isin || !(input.count > 0)) {
            event.preventDefault();
            showStatus($panel, $panel.data('text-error'), true);
            return;
        }

        const link = shareUrl(input);
        if (this.dataset.share === 'telegram') {
            this.href = `https://t.me/share/url?url=${encodeURIComponent(link)}&text=${encodeURIComponent($panel.data('text-share'))}`;
            return;
        }

        const showManual = () => showStatus($panel, `${$panel.data('text-manual')} ${link}`, false);
        if (!navigator.clipboard) {
            showManual();
            return;
        }
        navigator.clipboard.writeText(link).then(() => showStatus($panel, $panel.data('text-copied'), false), showManual);
    });

    $panel.on('click', '[data-save-calc]', function (event) {
        const input = currentInput(this.dataset.saveCalc);
        if (!input.isin || !(input.count > 0)) {
            event.preventDefault();
            showStatus($panel, $panel.data('text-error'), true);
            return;
        }

        if (!isAuthenticated) {
            writeDraftCookie(input);
            return;
        }

        $.post($panel.data('save-url'), {
            isin: input.isin,
            count: input.count,
            price: input.price,
            next: input.next,
            __RequestVerificationToken: $panel.find('input[name="__RequestVerificationToken"]').val()
        }).done(result => {
            if (!result.success) {
                showStatus($panel, $panel.data('text-error'), true);
            } else if (result.redirect) {
                location.href = result.redirect;
            } else {
                showStatus($panel, $panel.data('text-saved'), false);
                loadList($panel);
            }
        }).fail(() => showStatus($panel, $panel.data('text-error'), true));
    });

    if (isAuthenticated) {
        loadList($panel);
    }
}
